//
//
//
//
//
//

var script = {
  name: 'ListItemIcon',
  setup() {
    return {};
  }
};
export { script as default };